import { Button, FormControlLabel, RadioGroup } from '@mui/material';
import Radio from '@mui/material/Radio';
import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing } from 'stylesheetB2b';
import { fontSize, fontWeight } from 'stylesheetB2b';

export const ProlongationButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 230px;
  height: ${getSpacing(10)};
  bottom: ${getSpacing(2)};
  padding-top: ${getSpacing(2)};
`;

export const ProlongationButton = styled(Button)<{ background: string | undefined }>`
  background-color: ${(props) => props.background} !important;
  color: black !important;
  border-radius: ${getSpacing(8)} !important;
  font-size: ${getSpacing(4)};
  margin-bottom: ${getSpacing(1)};
  height: ${getSpacing(8)};
  width: 90%;
  font-weight: 500;
  &:disabled {
    background-color: #C0C0C0 !important;
    color: white !important;
  }
`;

export const CloseButton = styled.button`
  width: 20%;
`;

export const OpenProlongationButtonStyle = (colors: ColormapInterface) => ({
  background: 'none',
  border: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: fontWeight.bold,
  color: colors.prolongationOpenModalButton,
  fontSize: fontSize.extraSmall,
});

export const ArrowContainer = styled.div`
  margin-top: ${getSpacing(0.5)};
`;

export const FieldSetContent = styled.div<{ isSelected: boolean; colors: ColormapInterface }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 76px;
  width: 88px;
  border-radius: 2px !important;
  background-color: white !important;
  user-select: none;
  border: ${(props) =>
    props.isSelected
      ? `3px solid ${props.colors.selectedProlongationElement};`
      : 'unset'} !important;
`;

export const ProlongationPriceContainer = styled.div`
  margin-left: ${getSpacing(0.5)};
`;

export const FieldSetContentLabelTime = styled.div<{ colors: ColormapInterface }>`
  color: ${(props) => props.colors.timeSliderTrackAndThumb};
  font-size: ${getSpacing(3)};
  display: flex;
  font-weight: 500;
`;

export const FieldSetContentLabelPrice = styled.div<{ colors: ColormapInterface }>`
  color: black;
  font-size: ${getSpacing(2.7)};
  font-weight: 300;
`;

export const ProlongationTimeContainer = styled.div`
  font-weight: ${fontWeight.light};
`;

export const PinkRadio = styled(Radio)<{ colors: ColormapInterface }>`
  display: none !important; 


  color: ${(props) => props.colors.unselectedProlongationElement} !important;
  background-color: white !important;
  height: 76px;
  width: 88px;
  border-radius: 2px !important;
  opacity: 1;
  padding: 0;
  transform: scale(1.1);

  &.Mui-checked {
  border: 2px solid ${(props) => props.colors.selectedProlongationElement} !important;
    color: ${(props) => props.colors.selectedProlongationElement} !important;
  }
`;

export const BamRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: row !important;
  justify-content: space-around;
  width: 90%;
  padding-left: ${getSpacing(1)};
  & .MuiTypography-body1 {
    width: 100%;
  }

  & .MuiFormControlLabel-labelPlacementStart {
    display: flex;
    justify-content: space-between;
    margin: ${getSpacing(0)};
  }
`;

export const BamFormControlLabel = styled(FormControlLabel)<{ display: string }>`
  display: ${(props) => props.display} !important;
`;
